import moment from 'moment';

import { Comment as API } from '@src/api/types';
import { Comment as Data } from '@src/types';

import generateUser from './user';

const Factory = (api: API): Data => ({
  id: api.id,
  content: api.comment,
  date: moment.unix(api.date / 1000),
  user: generateUser(api.user),
  parentId: api.parentId,
  isReply: api.isReply,
  repliesCount: api.repliesCount,
});

export default Factory;
